import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPaperclip2"><Path d="M6.5 8.5V16C6.5 19.0376 8.96243 21.5 12 21.5C15.0376 21.5 17.5 19.0376 17.5 16V5.25C17.5 3.73122 16.2688 2.5 14.75 2.5C13.2312 2.5 12 3.73122 12 5.25V15.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPaperclip2;
